import React, { useMemo } from "react";

import { Role } from "../../../../../../../../../../services";
import { useAppContext } from "../../../../../../../../../../context";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

const CreatedAtCellContent: React.FC<CreatedAtCellContent.Props> = ({
	item,
}) => {
	const { dateFns } = useAppContext();

	const content = useMemo(
		() =>
			item.createdAt
				? dateFns.formatTime(item.createdAt, "dd.MM.yyyy")
				: "",
		[dateFns, item.createdAt],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace CreatedAtCellContent {
	interface Props {
		item: Role.Model;
	}
}

export default CreatedAtCellContent;
